
import api from "./api";

/* ---------------- GET LEAVES ---------------- */

export const getLeaves = async () => {
  const res = await api.get(`/salary/leave_applications`);

  const raw = res.data?.data || [];

  const leaves = raw.map((l: any) => ({
    _id: String(l.id),
    employeeId: l.employeeID,
    employeeName: l.name || "Employee",
    leaveType: l.leaveType || "personal",
    startDate: l.fromDate,
    endDate: l.toDate,
    days: l.totalDays || 0,
    reason: l.reason,
    status: l.status?.toLowerCase(),
    appliedDate: l.applied_on || l.decision_on,
    approvedBy: l.decision_by || null,
    managerID: l.managerID || null,
    managerComments: "",
  }));

  return { leaves };
};

// -------------SHOW LEAVE EXCLUDE EMPLOYEE---------
export const getMyLeaves = async () => {
  const res = await api.get(`/salary/leave_applications_all`);

  const raw = res.data?.data || [];

  const Leaves = raw.map((l: any) => ({
    _id: String(l.id),
    employeeId: l.employeeID,
    employeeName: l.name || "Employee",
    leaveType: l.leaveType || "personal",
    startDate: l.fromDate,
    endDate: l.toDate,
    days: l.totalDays || 0,
    reason: l.reason,
    status: l.status?.toLowerCase(),
    appliedDate: l.applied_on || l.decision_on,
    approvedBy: l.decision_by || null,
    managerID: l.managerID || null,
    managerComments: "",
  }));

  return { Leaves };
};


/* ---------------- APPLY LEAVE ---------------- */
export const applyLeave = async (payload: {
  employeeID: string;
  managerID: string;
  name: string;
  leaveType: string;
  fromDate: string;
  toDate: string;
  totalDays: number;
  reason: string;
  status: string;
}) => {
  const res = await api.post("/salary/apply_leave", payload);
  return res.data;
};


/* ---------------- APPROVE / REJECT ---------------- */
export const updateLeaveStatus = async (
  leaveId: string,
  status: "approved" | "rejected",
  comments?: string
) => {
  const backendStatus = status.toUpperCase(); 

  const res = await api.put(
    `/salary/approve_leave/${leaveId}?status=${backendStatus}`
  );

  return res.data;
};

/* ---------------- LEAVE BALANCE (EMPLOYEE ONLY) ---------------- */
// export const getLeaveBalance = async () => {
//   try {
//     const res = await api.get(
//       `/salary/get_details_for_leave_application`
//     );

//     return {
//       balance: res.data?.data || {},
//     };
//   } catch (err: any) {
//     return { balance: {} };
//   }
// };

export const getLeaveBalance = async () => {
  const res = await api.get(
    `/salary/get_details_for_leave_application`
  );

  return {
    balance: res.data?.data?.balance || {},
    managerID: res.data?.data?.managerID || null,
    employeeID: res.data?.data?.employeeID || null,
    epmtID: res.data?.data?.id || null,
  };
};


/* ---------------- CANCEL (OPTIONAL) ---------------- */
export const cancelLeave = async (leaveId: string) => {
  const res = await api.put(`/salary/cancel_leave/${leaveId}`);
  return res.data;
};
